import { Component, OnInit, HostListener, ViewChild, AfterViewInit, AfterContentChecked } from '@angular/core'; 
import { Router, NavigationEnd } from '@angular/router';
import { Settings, AppSettings } from '../app.settings';
import { AppService } from '../app.service';
import { SidenavMenuService } from '../theme/components/sidenav-menu/sidenav-menu.service';
import { CategoryService } from '../shared/category-list/category.service';
import { SubCategoryModel } from '../shared/category-list/models/subcategory';
import { PageService } from './pages.service';
import { SearchModel } from './Models/search-model';
import { CartModel } from './cart/cart.model';
import { WikalaService } from 'src/app/shared/services/wikala.service';
import { UserService } from '../shared/services/user.service';
import { AngularDeviceInformationService } from 'angular-device-information';
import { MobileLinksComponent } from '../shared/mobile-links/mobile-links.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss'],
  providers: [ SidenavMenuService ],
})
export class PagesComponent implements OnInit, AfterViewInit, AfterContentChecked {
  @ViewChild('sidenav', { static: true }) sidenav: any;

  public categories: SubCategoryModel[] = [];
  public category: SubCategoryModel;
  public searchModel: SearchModel = {};
  public sidenavMenuItems: Array<any>;
  public settings: Settings;
  public productAddedToCart: CartModel[] = [];
  public productTotal: number = 0;
  
  // خصائص البحث
  public keyword = 'productName';
  public fe = 'في قسم';
  public data: any[] = [];
  public errorMsg: string = '';
  public isLoadingResult: boolean = false;
  public showBackToTop: boolean = false;
  public OS: string = '';
  public searchTimeout: any;

  constructor(
    public appSettings: AppSettings, 
    public appService: AppService, 
    public sidenavMenuService: SidenavMenuService,
    public router: Router,
    private categoryService: CategoryService,
    private pageService: PageService,
    public userService: UserService,
    public WikalaService: WikalaService,
    private deviceInformationService: AngularDeviceInformationService,
    public dialog: MatDialog
  ) { 
    this.settings = this.appSettings.settings; 
  }

  ngOnInit() {
    this.initDeviceCheck();
    this.initCart();
    this.sidenavMenuItems = this.sidenavMenuService.getSidenavMenuItems();
    this.getCategories();
  }

  ngAfterViewInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) { 
        if (this.sidenav) this.sidenav.close(); 
      }                
    });
    this.sidenavMenuService.expandActiveSubMenu(this.sidenavMenuService.getSidenavMenuItems());
  }

  ngAfterContentChecked() {
    this.productTotal = +(this.WikalaService.calculateTotal().toFixed(2));
  }

  private initDeviceCheck() {
    this.OS = this.deviceInformationService.getDeviceInfo().os;
    if (this.OS === "Android" || this.OS === "iOS") {
      this.openProductDialog();
    }
  }

  private initCart() {
    this.productAddedToCart = this.WikalaService.getProductFromCart() || [];
  }

  public openProductDialog() {   
    this.dialog.open(MobileLinksComponent, {
        panelClass: 'product-dialog',
        direction: this.settings.rtl ? 'rtl' : 'ltr',
        width: '600px',
    });
  }

  // === دوال البحث ===
  public getServerResponse(event: string) {
    if (!event || event.trim().length < 2) {
      this.searchCleared();
      return;
    }
    if (this.searchTimeout) clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(() => {
      this.searchModel.name = event;
      this.isLoadingResult = true;
      this.pageService.search(this.searchModel).subscribe({
        next: (data: any) => {
          if (data?.Error) {
            this.data = [];
            this.errorMsg = data.Error;
          } else {
            this.data = data || [];
          }
          this.isLoadingResult = false;
        },
        error: () => {
          this.errorMsg = 'حدث خطأ أثناء البحث';
          this.isLoadingResult = false;
        }
      });
    }, 350);
  }
 
  public searchCleared() {
    this.data = [];
    this.errorMsg = '';
  }
 
  public selectEvent(item: any) {
    this.router.navigate(['search-result', item.productName, item.categoryNameEn]);
    this.searchCleared();
  }

  public goToProducts(item: any) {
    this.router.navigateByUrl(`/products/${item.categoryNameEn}/${item.subCategoryNameEn}`);
    this.searchCleared();
  }

  public search() {
    if (this.searchModel.name && this.searchModel.name.trim()) {
      this.router.navigate(['search-result', this.searchModel.name]);
    }
  }

  public getCategories() {   
    this.categoryService.getAllSubCategorys().subscribe((data) => {
      if (data && data.length) {
        this.categories = data; 
        this.category = data[0];
      }
    }); 
  }

  public closeSubMenus() {
    if (window.innerWidth < 960) {
      this.sidenavMenuService.closeAllSubMenus();
    }    
  }

  // === التمرير والعودة للأعلى ===
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.showBackToTop = window.scrollY > 400;
  }

  public scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  public stopClickPropagate(event: any) {
    event.stopPropagation();
  }
}